var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profileCver"},[(_vm.loading)?_c('app-loading',{attrs:{"active":true}}):_vm._e(),(_vm.src && !_vm.loading)?_c('img',{attrs:{"src":_vm.src}}):_c('svg',{staticClass:"size-holder",attrs:{"viewBox":"0 0 5 1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }